export function getFirstTextRect(root) {
  if (!root) {
    return null;
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let textNode;

  while ((textNode = walker.nextNode())) {
    if (!(textNode.nodeValue || '').trim()) {
      continue;
    }

    const range = document.createRange();
    range.selectNodeContents(textNode);
    const rect = Array.from(range.getClientRects()).find(
      ({ width, height }) => width > 0 && height > 0
    );
    range.detach();

    if (rect) {
      return rect;
    }
  }

  return null;
}

export function getFirstSvgTextRect(root) {
  if (!root) {
    return null;
  }

  for (const tspan of Array.from(root.querySelectorAll('tspan'))) {
    if (!(tspan.textContent || '').trim()) {
      continue;
    }

    const rect = tspan.getBoundingClientRect();

    if (rect.width > 0 && rect.height > 0) {
      return rect;
    }
  }

  return null;
}
